import { Cartesian3, Color } from "cesium"
import * as turf from '@turf/turf'

const colors = {
    red: Color.RED,
    chartreuse: Color.CHARTREUSE,
    blue: Color.BLUE,
    yellow: Color.YELLOW,
    orange: Color.ORANGE,
    deeppink: Color.DEEPPINK,
    white: Color.WHITE,
    black: Color.BLACK,
    deepskyblue: Color.DEEPSKYBLUE,
    orangered: Color.ORANGERED,
    royalblue: Color.ROYALBLUE
}

/**生成UUID */
export function createUUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0,
          v = c == 'x' ? r : (r & 0x3 | 0x8)
      return v.toString(16)
    })
}

/**
 * 转换颜色
 * @param {Array<Number> | String} color 
 * @param {Number} alpha 
 */
export function changeColor(color, alpha = 1.0) {
    if(!color) {
        throw new Error('颜色不能为空！')
    }
    if(typeof color === 'string') {
        if(color.startsWith('#')) {
            return Color.fromCssColorString(color).withAlpha(alpha)
        }else if(color.startsWith('rgba')) {
            color = color.replace('rgba','').replace('(', '').replace(')', '')
            const colorArr = color.split(',')
            return Color.fromBytes(Number(colorArr[0]),Number(colorArr[1]),Number(colorArr[2]), Math.floor(Number(colorArr[3]) * 255))
        }else if(color.startsWith('rgb')) {
            color = color.replace('rgb','').replace('(', '').replace(')', '')
            const colorArr = color.split(',')
            return Color.fromBytes(Number(colorArr[0]),Number(colorArr[1]),Number(colorArr[2]), 255)
        }else {
            return colors[color]
        }
    }else if(Array.isArray(color)) {
        if(color.length > 3) {
            return Color.fromBytes(color[0], color[1], color[2], color[3])
        }else if(color.length == 3) {
            return Color.fromBytes(color[0], color[1], color[2], 255)
        }else{
            throw new Error('数组格式颜色不能低于3个！')
        }
    }else{
        throw new Error('颜色格式不正确！')
    }
}

/**
 * 
 * @param {Array<Number>} start 
 * @param {Array<Number>} end 
 * @param {Number} count 
 * @returns 
 */
export function getSteps(start, end, count) {
    let arc = []
    const line = turf.lineString([start, end])
    const lineLength = turf.length(line);
    for(let i=0; i<lineLength; i += lineLength / count) {
        const segment = turf.along(line, i);
        const position = Cartesian3.fromDegrees(...segment.geometry.coordinates)
        arc.push(position);
    }
    return arc
}

// -----------------纬度------------------
const latFilter = function(value) {
    if (value === null || value === undefined || value === 'NaN') {
        return ''
    } else {
        return value
    }
}

    // 输出33° 84′ S的形式
export function latStrFilter(value) {
    const lat = latFilter(parseFloat(value)).toString()
    if (!lat) {
        return undefined
    }
    let latDir = ''
    if (Number(lat) < 0) {
        latDir = 'S'
    } else {
        latDir = 'N'
    }
    const degree = parseInt(lat)
    const minute = Math.abs((parseFloat(lat) - degree) * 60)
    if (degree < 0) {
        return `${-degree}° ${minute.toFixed(2)}′ ${latDir}`
    } else {
        return `${degree}° ${minute.toFixed(2)}′ ${latDir}`
    }
}

// -------------------经度-------------
const lonFilter = function(value) {
    if (value === null || value === undefined || value === 'NaN') {
      return ''
    } else {
      if (value < -180) {
        return value + 360
      } else if (value > 180) {
        return value - 360
      } else {
        return value
      }
    }
}
  
  // 输出33° 84′ W的形式
export function lonStrFilter(value) {
    const lon = lonFilter(parseFloat(value)).toString()
    if (!lon) {
      return undefined
    }
    let lonDir = ''
    if (Number(lon) < 0 || Number(lon) > 180) {
      lonDir = 'W'
    } else {
      lonDir = 'E'
    }
    const degree = parseInt(lon)
    const minute = Math.abs((parseFloat(lon) - degree) * 60)
    if (degree < 0) {
      return `${-degree}° ${minute.toFixed(2)}′ ${lonDir}`
    } else {
      return `${degree}° ${minute.toFixed(2)}′ ${lonDir}`
    }
}